/* eslint-disable @typescript-eslint/no-this-alias */
import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from 'src/app/shared/modal.service';
import { Router } from '@angular/router';
import { ProductosService } from 'src/app/business/productos.service';
import { AppConfiguration } from 'src/app/app.configuration';
import { VentaService } from 'src/app/core/services/venta.service';
import { PaymentService } from 'src/app/core/payment/payment.service';
import * as moment from 'moment';
import { CalendarService } from 'src/app/business/ticket-sales/pages/date-selector/calendar/calendar.service';
import { PaymentGateway } from 'src/app/core/payment/paymentGateway.enum';
import { PayMethodEnum } from '../../interfaces/resume.interface';
import { Compra } from 'src/app/models/compra.model';
@Component({
  selector: 'app-modal-timer',
  templateUrl: './modal-timer.component.html',
  styleUrls: ['./modal-timer.component.scss']
})
export class ModalTimerComponent implements OnInit, OnDestroy {
  @Input() id: string;
  private element: any;
  level = -1;
  proyecto = '';
  payMethodEnum = PayMethodEnum;

  constructor(
    private modalService: ModalService,
    private router: Router,
    private el: ElementRef,
    private productosService: ProductosService,
    private config: AppConfiguration,
    private ventaService: VentaService,
    private paymentService: PaymentService,
    private calendarService: CalendarService
  ) {
    this.element = el.nativeElement;
  }

  ngOnInit(): void {
    const modal = this;
    this.proyecto = this.config.getProyecto();

    if (!this.id) {
      return;
    }

    document.body.appendChild(this.element);

    this.element.addEventListener('click', function (e: any) {
      if (e.target.className === 'modalTimer') {
        modal.close();
      }
    });
    this.modalService.add(this);
  }

  open(): void {
    this.element.style.display = 'block';
    // document.body.classList.add("selectorNONumerado");
    this.level = this.modalService.info;
    // this.posicionVenta = this.modalService.butacas[0];
  }

  modify() {
    // this.carrito.modificar(this.modalService.butacas);
    this.close();
  }

  // remove self from modal service when directive is destroyed
  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }
  close(): void {
    this.element.style.display = 'none';
    document.body.classList.remove('modalTimer');
    // necesitamos pasarnos a teinda menu cuando se vence el tiempo

    // Limpiamos todos los valores para no generar errores
    this.resetValues();

    this.ir();
    // this.modalService.info=null
    // this.modalService.butacas=null
  }

  resetValues() {
    this.ventaService.setFechaSeleccionadaValue(moment());
    this.calendarService.currentDate = moment();
    sessionStorage.removeItem('descuento');
    // sessionStorage.removeItem("factura");
    sessionStorage.removeItem('pedido');
    sessionStorage.removeItem('localizador');
    sessionStorage.removeItem('payment');

    this.ventaService.setIsReservaPagadaValue(false);

    this.ventaService.setCompra(new Compra());
    this.ventaService.sesionesReservadas = [];
    this.ventaService.setDescuentoObjeto(undefined);
    this.ventaService.setDescuentoCod(undefined);
    this.ventaService.setDescuento(undefined);
    this.ventaService.setDescuentoComisiones(undefined);
    this.ventaService.setDescuentoPer(undefined);
    this.ventaService.setDescuentoPersonalizado(undefined);
    this.ventaService.setDescuentoTotales(undefined);
    this.ventaService.setDescuentoClienteAsociado(undefined);
    this.ventaService.setDescuentoClienteAsociadoCod(undefined);
    this.ventaService.setDescuentoClienteAsociadoObjeto(undefined);
    this.productosService.setFiltroTipoValue('');
    this.productosService.setFiltroGrupoValue('');
    this.productosService.setFiltroNivelValue('');
    this.ventaService.setCambios(false);
    this.paymentService.setMostrarBotonesPagar(false);
    this.paymentService.setMostrarBotonesReservar(false);
    this.paymentService.setMostrarBotonesPhone(false);
    this.paymentService.setMostrarBotonesBizum(false);
    this.paymentService.setmostrarBotonesPaypal(false);
    this.paymentService.setMostrarDescuento(false);
    this.paymentService.setPaymentGateway(PaymentGateway.REDSYS);
    sessionStorage.setItem('payment', JSON.stringify(PaymentGateway.REDSYS));
    sessionStorage.setItem('payMethod', this.payMethodEnum.IN);
  }

  ir() {
    /* const enlaceMenu = this.productosService.getEnlaceMenuId();
    if (enlaceMenu && enlaceMenu.iPadre) {
      this.router.navigate(['/tienda/productos'], { queryParams: { iPadre: enlaceMenu.iPadre } });
    } else {
      this.router.navigate(['/tienda/productos']);
    } */
    this.productosService.setDatosInitValue(undefined);
    this.router.navigate(['/tienda/productos']);
  }
}
